module.exports = __webpack_public_path__ + "img/2.da4b5ca6.png";